import useTranslator from "../../hooks/useTranslator";
import ProfileImg from "../../assets/img/profileImg.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import { haveValue } from "../../helper/common";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import { useState } from "react";

const DetailsPersonalInfo = (props) => {
  const { user = null, forensicAnalysis = {}, handleInfoModal } = props;
  const { _t } = useTranslator();
  const [showTooltip, setshowTooltip] = useState(false);

  return (
    <>
      <div className="main_doc_div">
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={ProfileImg} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("personalInformation")}</p>
        </div>
        <div className="row">
          <div className="col-4">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(forensicAnalysis?.Name)
                  ? "custom-tooltip cursor-pointer"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (haveValue(forensicAnalysis?.Name)) {
                  handleInfoModal(forensicAnalysis?.Name);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("name")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.Name?.verifiedSource === true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(forensicAnalysis?.Name?.dataInJSON?.name)
                  ? forensicAnalysis?.Name?.dataInJSON?.name
                  : `${user?.fname ?? ""} ${user?.lname ?? ""}`}
              </p>
            </div>
          </div>
          {(haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni) ||
            haveValue(
              forensicAnalysis?.Passport?.dataInJSON?.passportNumber
            )) && (
            <div className="col-4">
              <div
                className={`Indo_form BorderB2 ${
                  haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni) ||
                  haveValue(
                    forensicAnalysis?.Passport?.dataInJSON?.passportNumber
                  )
                    ? "custom-tooltip cursor-pointer"
                    : ""
                }`}
                data-tooltip={_t("clickHereToSeeDetails")}
                onClick={() => {
                  if (haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni)) {
                    handleInfoModal(forensicAnalysis?.DNI);
                  } else if (
                    haveValue(
                      forensicAnalysis?.Passport?.dataInJSON?.passportNumber
                    )
                  ) {
                    handleInfoModal(forensicAnalysis?.Passport);
                  }
                }}
              >
                <div className="d-flex align-items-center gap-1">
                  <p className="formlabel d-block">
                    {haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni)
                      ? _t("dniNie")
                      : _t("passport")}
                  </p>
                  {(forensicAnalysis?.DNI?.verifiedSource === true ||
                    forensicAnalysis?.Passport?.verifiedSource === true) && (
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={CheckIcon0}
                        alt="Vector Icon"
                        className="validationIcon"
                      />
                    </div>
                  )}
                </div>

                <p className="placeholderTest">
                  {haveValue(forensicAnalysis?.DNI?.dataInJSON?.dni)
                    ? forensicAnalysis?.DNI?.dataInJSON?.dni
                    : forensicAnalysis?.Passport?.dataInJSON?.passportNumber}
                </p>
              </div>
            </div>
          )}

          <div className="col-4">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(forensicAnalysis?.Nationality)
                  ? "cursor-pointer custom-tooltip"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (haveValue(forensicAnalysis?.Nationality)) {
                  handleInfoModal(forensicAnalysis?.Nationality);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("nationality")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.Nationality?.verifiedSource === true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(
                  forensicAnalysis?.Nationality?.dataInJSON?.nationality
                )
                  ? _t(
                      forensicAnalysis?.Nationality?.dataInJSON?.nationality,
                      "",
                      "fixed"
                    )
                  : haveValue(user?.nationality)
                  ? _t(user?.nationality, "", "fixed")
                  : "N/A"}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div className="Indo_form BorderB2">
              <p className="formlabel d-block">{_t("phoneNumber")}</p>
              <p className="placeholderTest">
                {user?.phone_number ? `+${user?.phone_number}` : "N/A"}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div className="Indo_form BorderB2">
              <p className="formlabel d-block">{_t("email")}</p>
              <p className="placeholderTest">{user?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsPersonalInfo;
